<app-spinner></app-spinner>
<router-outlet></router-outlet>
<title>{{ page | titlecase }} Business</title>
<app-scroll-to-top></app-scroll-to-top>
<app-idle-timeout-dialog
  [visible]="showIdleDialog"
  (onContinue)="onIdleContinue()"
  (onLogout)="onIdleLogout()">
</app-idle-timeout-dialog>